import { ITruckImplement } from 'app/shared/model/truck-implement.model';

export interface IKpiLastProcessed {
  id?: number;
  sensorData?: number | null;
  truckImplement?: ITruckImplement | null;
}

export const defaultValue: Readonly<IKpiLastProcessed> = {};
